import { createContext } from 'react';
import { LayoutSettings } from '@/types';
import { organizationConfig } from '@/context/AdminLayoutContext';

export interface ILayoutContext {
  isMobile?: boolean;
  layoutConfig: LayoutSettings;
  siderWidth: number;
}

const layoutContext = createContext<ILayoutContext>({
  siderWidth: 200,
  layoutConfig: organizationConfig['ARYA'],
});

export default layoutContext;
